import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useTheme } from 'next-themes';

const DARK_ALLOWED_PREFIXES = [
  '/login', '/register', '/forgot-password', '/reset-password',
  '/verify-email', '/profile',
  '/platform', '/restaurant',
];

const ThemeScope = () => {
  const { pathname } = useLocation();
  const { theme, setTheme } = useTheme();
  const savedTheme = useRef<string | undefined>();

  const isAllowed = DARK_ALLOWED_PREFIXES.some(p => pathname.startsWith(p));

  useEffect(() => {
    if (!isAllowed) {
      if (theme !== 'light') {
        savedTheme.current = theme;
        setTheme('light');
      }
    } else if (savedTheme.current) {
      setTheme(savedTheme.current);
      savedTheme.current = undefined;
    }
  }, [isAllowed]);

  return null;
};

export default ThemeScope;
